"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Economy = void 0;
var create_entity_1 = require("../../utils/create-entity");
var economy_card_1 = require("../../components/entities/economy-card");
var economy_details_layout_1 = require("../../components/entities/economy-details-layout");
var graphql_1 = require("../../utils/graphql");
var ITEMS_PER_PAGE = 9;
exports.Economy = {
  name: 'Economy',
  label: 'Country',
  pluralLabel: 'Countries',
  slug: 'country',
  groupName: 'Places',
  pluralSlug: 'countries',
  useDuplicateCheck: true,
  useSites: true,
  useConversation: true,
  useConnections: true,
  useSlices: true,
  useSpaces: true,
  useFollowers: true,
  includeInSearch: true,
  includeInMetrics: true,
  useVisibility: true,
  useModerators: true,
  usePermissions: true,
  canEmbed: true,
  autoRoutes: ["list", "details", "update"],
  platformActivity: {
    tab: 'overview'
  },
  filters: {
    fields: {
      globalRegions: {
        entityTypeName: 'GlobalRegion'
      }
    }
  },
  select: {
    canCreate: function (_a) {
      var currentUserCan = _a.currentUserCan;
      return currentUserCan(['write:any', 'create:economies']);
    },
    maxWidth: '800px',
    queryFields: "\n      id name iso shorthand\n    ",
    /*
    We search on a "label" field instead, so that the shorthand is also searched.
    This is really handy for searching for places like USA, or UK
    */
    loadOptionsFilter: function (inputValue) {
      return {
        label: {
          contains: inputValue
        }
      };
    }
  },
  components: {
    card: economy_card_1.EconomyCard,
    details: economy_details_layout_1.EconomyDetailsLayout
  },
  /* ----------------- DETAILS ---------------- */
  details: {
    label: 'Overview',
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      locations { ...EntityValueFields }\n      people { ...EntityValueFields }\n      organisations { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n      feedEntries { id }\n      name\n      id\n      latitude\n      longitude\n      description { id text textTruncated: text(truncate: { words: 80 }) }\n      population\n      areaInSquareKm\n      densityPerSquareKm\n      gdp\n      perCapitaIncome\n      medianHouseholdIncome\n      quotes { ...EntityValueFields person { ...EntityValueFields } }\n      files { ...FileAssetValueFields }\n\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      organisationsBenefiting {\n        id\n        name\n        slug\n        url\n        description {\n          id\n          text(truncate: { words: 50 })\n          html(truncate: { words: 25 })\n        }\n        logo {\n          id\n          url\n        }\n      }\n      impactResults {\n        id slug name title\n        description { id text html }\n        type { id name slug label }\n      }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      links { id name slug label url description { id text html } types { id name slug } image { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } } }\n    "], ["\n      locations { ...EntityValueFields }\n      people { ...EntityValueFields }\n      organisations { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n      feedEntries { id }\n      name\n      id\n      latitude\n      longitude\n      description { id text textTruncated: text(truncate: { words: 80 }) }\n      population\n      areaInSquareKm\n      densityPerSquareKm\n      gdp\n      perCapitaIncome\n      medianHouseholdIncome\n      quotes { ...EntityValueFields person { ...EntityValueFields } }\n      files { ...FileAssetValueFields }\n\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      organisationsBenefiting {\n        id\n        name\n        slug\n        url\n        description {\n          id\n          text(truncate: { words: 50 })\n          html(truncate: { words: 25 })\n        }\n        logo {\n          id\n          url\n        }\n      }\n      impactResults {\n        id slug name title\n        description { id text html }\n        type { id name slug label }\n      }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      links { id name slug label url description { id text html } types { id name slug } image { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } } }\n    "])))
  },
  export: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      latitude longitude\n      description { text }\n      people { name }\n      feedEntries { name url }\n\n      challenges { name }\n      keyIssues { name }\n      trends { name }\n      topics { name }\n      subTopics { name }\n    "], ["\n      latitude longitude\n      description { text }\n      people { name }\n      feedEntries { name url }\n\n      challenges { name }\n      keyIssues { name }\n      trends { name }\n      topics { name }\n      subTopics { name }\n    "])))
  },
  list: {
    applyVisibilityState: true,
    banner: {
      content: 'Explore the network by {{ECONOMY}}'
    },
    hasSearch: true,
    queryFields: (0, graphql_1.graphql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      latitude\n      longitude\n      population\n      description { id plain(truncate: { words: 45 }) }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n\n      globalRegions { ...EntityValueFields }\n\n      organisations { id }\n      people { id }\n      feedEntries { id }\n      locations { id }\n    "], ["\n      latitude\n      longitude\n      population\n      description { id plain(truncate: { words: 45 }) }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n\n      globalRegions { ...EntityValueFields }\n\n      organisations { id }\n      people { id }\n      feedEntries { id }\n      locations { id }\n    "]))),
    baseState: {
      limit: ITEMS_PER_PAGE,
      filter: {
        isPublished: {
          is: true
        }
      }
    }
  },
  form: {
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'library'
    }, {
      name: 'data'
    }, {
      name: 'activity'
    }, {
      name: 'stats'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      banner: {
        type: 'banner'
      },
      description: {
        type: 'description',
        useCompletions: true
      },
      globalRegions: {
        type: 'linkedMultiple',
        entityTypeName: 'GlobalRegion',
        fieldSet: 'overview',
        recommended: false,
        description: 'Which {{GLOBAL_REGIONS}} is this {{ECONOMY}} part of?'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        fieldSet: 'library'
      },
      quotes: {
        type: 'linkedMultiple',
        entityTypeName: 'Quote',
        fieldSet: 'library'
      },
      files: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset',
        fieldSet: 'library'
      },
      impactResults: {
        type: 'linkedTable',
        entityTypeName: 'ImpactResult',
        description: 'Describe the latest results and achievements in this {{ECONOMY}}',
        fieldSet: 'activity'
      },
      indicatorResults: {
        type: 'linkedTable',
        entityTypeName: 'IndicatorResult',
        fieldSet: 'data'
      },
      /* ----- Statistics ----- */
      population: {
        type: 'float',
        fieldSet: 'stats',
        description: 'What is the current (actual or estimated) population of this {{ECONOMY}}?'
      },
      areaInSquareKm: {
        type: 'float',
        fieldSet: 'stats',
        description: 'What is the area of this {{ECONOMY}} in square kilometres?'
      },
      densityPerSquareKm: {
        type: 'float',
        fieldSet: 'stats',
        description: 'What is the density (number of people) of this {{ECONOMY}} per square kilometre?'
      },
      gdp: {
        type: 'float',
        fieldSet: 'stats',
        label: 'GDP (USD)',
        description: 'What is the Gross Domestic Product (GDP) of this {{ECONOMY}}, in US Dollars (USD)?'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      }
    })
  }
};
var templateObject_1, templateObject_2, templateObject_3;